import axios from "axios";

// Base URL del backend, decisa a RUNTIME (non dipende dai file .env nel build):
// - in locale (localhost/127.0.0.1) usa il backend di sviluppo, da .env o :8002;
// - altrove (produzione) resta vuota → API = "/api" relativo, che nginx inoltra
//   a uvicorn sullo stesso dominio (niente localhost nel browser dell'utente).
const isLocalDev =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");
export const BACKEND_URL = isLocalDev
  ? process.env.REACT_APP_BACKEND_URL || "http://localhost:8002"
  : "";
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Errore imprevisto";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

export default api;
